export default __webpack_public_path__ + "static/media/interface-3614766_640.b673dbc1.png";